var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileExpensePurpleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90241 1.36054C5.35731 1.27177 4.84345 1.64169 4.75468 2.18681L3.30814 11.0698L3.12732 12.1802L8.98678 1.86281L8.36991 1.76236L5.90241 1.36054Z",
    stroke: "#7647EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.905 0.848593C10.4301 0.566718 9.81658 0.723204 9.53469 1.19815L4.94122 8.93766L3 12L14.1298 2.76254L13.0549 2.12456L10.905 0.848593Z",
    stroke: "#7647EE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63524 14.6348C1.27878 14.2129 1.33178 13.582 1.75362 13.2255L15.5023 1.60772C15.9242 1.25125 16.5551 1.30427 16.9116 1.72611L23.3659 9.36427C23.7224 9.78612 23.6694 10.417 23.2475 10.7735L9.49883 22.3913C9.07699 22.7478 8.44605 22.6948 8.08958 22.2729L1.63524 14.6348Z",
    fill: "#7647EE",
    stroke: "#7647EE",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7909 13.5271C14.6346 12.8142 14.7406 11.5523 14.0277 10.7086C13.3148 9.8649 12.0529 9.7589 11.2092 10.4718C10.3655 11.1848 10.2595 12.4466 10.9724 13.2903C11.6854 14.134 12.9473 14.24 13.7909 13.5271Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74577 17.9226L8.02763 17.1465L7.79208 17.3645L7.61325 17.1712L7.84879 16.9532L7.61966 16.7056L7.38411 16.9236L7.20528 16.7303L7.44082 16.5123L6.75063 15.7665L7.06469 15.4758L8.04176 15.9563L8.3981 15.6265L7.7079 14.8807L7.94647 14.6599L8.63666 15.4058L8.87221 15.1878L9.05104 15.3811L8.8155 15.5991L9.04463 15.8467L9.28017 15.6287L9.45901 15.822L9.22347 16.04L9.94161 16.816L9.62453 17.1094L8.61951 16.5988L8.26317 16.9285L8.98131 17.7046L8.74577 17.9226ZM8.08434 16.7353L8.3682 16.4726L8.04847 16.3088L7.84916 16.4932L8.08434 16.7353ZM9.30904 16.611L9.32112 16.5998L8.98792 16.2579L8.86109 16.3753L9.30904 16.611ZM7.67033 16.3L7.79716 16.1826L7.32383 15.9255L7.31175 15.9367L7.67033 16.3ZM8.60978 16.2491L8.81211 16.0618L8.57693 15.8198L8.29005 16.0853L8.60978 16.2491Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1498 9.24814L15.6507 6.74906L18.1498 9.24814Z",
    fill: "#300F88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0252 9.623L18.0873 8.56089C18.3289 8.31935 18.3289 7.92775 18.0873 7.68621C17.8458 7.44468 17.4542 7.44468 17.2127 7.68621L16.5879 8.31098C16.3464 8.55252 15.9548 8.55252 15.7132 8.31098C15.4717 8.06945 15.4717 7.67784 15.7132 7.43631L16.7753 6.3742M18.1498 9.24814L15.6507 6.74906",
    stroke: "white",
    strokeWidth: 0.353422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileExpensePurpleIcon);
export default __webpack_public_path__ + "static/media/mobileExpensePurpleIcon.e63bc05fb862478815ee9c083017b8a0.svg";
export { ForwardRef as ReactComponent };